import React from "react";

import { FormattedMessage, useIntl } from "react-intl";

import Heading from "@atlaskit/heading";
import { Stack } from "@atlaskit/primitives-next";

import { GenericErrorDisplay } from "../../../../common/displays";
import { FastshiftTable } from "../../../../common/fastshift-table";
import { useMigrationStatusTable } from "../hooks/use-migration-status-table";

import { messages } from "./messages";

export const MigrationStatusTable: React.FC = () => {
    const {
        isTableLoading,
        isTableError,
        rows,
        head,
        controls,
        handleRefresh
    } = useMigrationStatusTable();

    const intl = useIntl();

    const ErrorComponent = (
        <GenericErrorDisplay
            customMessage={intl.formatMessage(messages.errorMessageDescription)}
            onRefresh={handleRefresh}
        />
    );

    return (
        <Stack space="space.100">
            <Heading size="small">
                <FormattedMessage {...messages.migrationStatusTableHeading} />
            </Heading>
            <FastshiftTable
                id="migration-status-table"
                enableSearch={false}
                isTableLoading={isTableLoading}
                isTableError={isTableError}
                errorComponent={ErrorComponent}
                head={head}
                rows={rows}
                controls={controls}
            />
        </Stack>
    );
};
